{
  "familyId": "TGL-TIJD-ANALOOG",
  "questions": [
    {
      "id": "TGL-TIJD-ANALOOG-001",
      "familyId": "TGL-TIJD-ANALOOG",
      "module": "TijdGeld",
      "tier": 1,
      "levelCode": "B6",
      "group": 6,
      "skill": "klokkijken",
      "subSkill": "klok_analoog",
      "questionType": "clock",
      "question": "Hoe laat is het op deze klok?",
      "options": ["03:15", "03:45", "03:30", "03:00"],
      "correctAnswer": 0,
      "data": {
        "mode": "read_analog_fill",
        "target": {"hours": 3, "minutes": 15, "format": "24h"},
        "minuteStep": 5,
        "showNumbers": true,
        "showMinuteTicks": true
      },
      "conceptId": "clock_reading_analog_quarter",
      "variantIndex": 1,
      "stimulusAids": [
        {
          "type": "clock",
          "data": {"hours": 3, "minutes": 15}
        }
      ],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Kwart over aflezen",
            "content": "De kleine wijzer staat tussen de 3 en de 4, dus het uur is 3. De grote wijzer wijst naar de 3, dat is kwart over (15 minuten). Het antwoord is 03:15."
          }
        }
      ],
      "feedback": {
        "explanationText": "Strategie: lees eerst de kleine wijzer (uur), dan de grote wijzer (minuten). Stap 1: de kleine wijzer staat tussen de 3 en de 4, dus het uur is 3. Stap 2: de grote wijzer wijst naar de 3 — tel: 3 × 5 = 15 minuten (kwart over). Stap 3: samen is dat 03:15.",
        "distractorExplanations": {
          "0": "Correct! De kleine wijzer staat bij de 3 en de grote wijzer bij de 3 (kwart over = 15 minuten). Dat is 03:15.",
          "1": "Veelgemaakte fout: kwart over en kwart voor verwarren. De grote wijzer staat op de 3 (kwart over = 15 minuten), niet op de 9 (kwart voor = 45 minuten). Onthoud: 3 = kwart over, 9 = kwart voor.",
          "2": "Veelgemaakte fout: de grote wijzer verkeerd aflezen. De grote wijzer staat op de 3, niet op de 6. De 3 = 15 minuten (kwart over), de 6 = 30 minuten (half). Het is 03:15, niet 03:30.",
          "3": "Veelgemaakte fout: de grote wijzer negeren. De grote wijzer staat niet op de 12 maar op de 3. Als de grote wijzer op de 12 staat = 0 minuten (heel uur). Op de 3 = 15 minuten."
        }
      }
    },
    {
      "id": "TGL-TIJD-ANALOOG-002",
      "familyId": "TGL-TIJD-ANALOOG",
      "module": "TijdGeld",
      "tier": 1,
      "levelCode": "B6",
      "group": 6,
      "skill": "klokkijken",
      "subSkill": "klok_analoog",
      "questionType": "clock",
      "question": "Hoe laat is het?",
      "options": ["07:30", "08:30", "07:00", "08:00"],
      "correctAnswer": 0,
      "data": {
        "mode": "read_analog_fill",
        "target": {"hours": 7, "minutes": 30, "format": "24h"},
        "minuteStep": 5,
        "showNumbers": true,
        "showMinuteTicks": true
      },
      "conceptId": "clock_reading_analog_half",
      "variantIndex": 2,
      "stimulusAids": [
        {
          "type": "clock",
          "data": {"hours": 7, "minutes": 30}
        }
      ],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Half acht aflezen",
            "content": "De kleine wijzer staat tussen de 7 en de 8. Bij 'half' kijk je naar het volgende uur, maar het is nog niet 8 uur. De grote wijzer staat op de 6 (half). Het antwoord is 07:30 (half acht)."
          }
        }
      ],
      "feedback": {
        "explanationText": "Strategie: lees eerst de kleine wijzer (uur), dan de grote wijzer (minuten). Stap 1: de kleine wijzer staat tussen de 7 en de 8, dus het uur is 7. Stap 2: de grote wijzer wijst naar de 6 — dat is 30 minuten (half). Stap 3: het is 07:30, ook wel 'half acht' genoemd.",
        "distractorExplanations": {
          "0": "Correct! De kleine wijzer staat tussen 7 en 8, en de grote wijzer op de 6 (half). Dat is 07:30.",
          "1": "Veelgemaakte fout: het volgende uur aflezen in plaats van het huidige. De kleine wijzer staat nog niet bij de 8, maar tussen de 7 en de 8. Bij 'half' schuift de kleine wijzer al richting het volgende uur, maar het is nog 7 uur.",
          "2": "Veelgemaakte fout: de grote wijzer verkeerd aflezen. De grote wijzer staat op de 6 (30 minuten), niet op de 12 (0 minuten). Als de grote wijzer op de 12 staat, is het een heel uur.",
          "3": "Veelgemaakte fout: beide wijzers verwarren. De kleine wijzer (kort) geeft het uur aan, de grote wijzer (lang) de minuten. De kleine staat tussen 7 en 8, de grote op de 6."
        }
      }
    },
    {
      "id": "TGL-TIJD-ANALOOG-003",
      "familyId": "TGL-TIJD-ANALOOG",
      "module": "TijdGeld",
      "tier": 1,
      "levelCode": "B6",
      "group": 6,
      "skill": "klokkijken",
      "subSkill": "klok_analoog",
      "questionType": "clock",
      "question": "Hoe laat is het op de klok?",
      "options": ["10:45", "10:15", "11:45", "09:45"],
      "correctAnswer": 0,
      "data": {
        "mode": "read_analog_fill",
        "target": {"hours": 10, "minutes": 45, "format": "24h"},
        "minuteStep": 5,
        "showNumbers": true,
        "showMinuteTicks": true
      },
      "conceptId": "clock_reading_analog_quarter_to",
      "variantIndex": 3,
      "stimulusAids": [
        {
          "type": "clock",
          "data": {"hours": 10, "minutes": 45}
        }
      ],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Kwart voor aflezen",
            "content": "De kleine wijzer staat tussen de 10 en de 11, dus het uur is 10. De grote wijzer wijst naar de 9, dat is kwart voor (45 minuten). Het antwoord is 10:45 (kwart voor elf)."
          }
        }
      ],
      "feedback": {
        "explanationText": "Strategie: lees eerst de kleine wijzer (uur), dan de grote wijzer (minuten). Stap 1: de kleine wijzer staat tussen de 10 en de 11, dus het uur is 10. Stap 2: de grote wijzer wijst naar de 9 — tel: 9 × 5 = 45 minuten (kwart voor). Stap 3: het is 10:45, ook wel 'kwart voor elf' genoemd.",
        "distractorExplanations": {
          "0": "Correct! De kleine wijzer staat bij de 10 en de grote wijzer bij de 9 (kwart voor = 45 minuten). Dat is 10:45.",
          "1": "Veelgemaakte fout: kwart over en kwart voor verwarren. De grote wijzer staat op de 9 (kwart voor = 45 minuten), niet op de 3 (kwart over = 15 minuten). Onthoud: 3 = kwart over, 9 = kwart voor.",
          "2": "Veelgemaakte fout: het volgende uur aflezen. De kleine wijzer staat nog niet bij de 11, maar tussen de 10 en de 11. Bij 'kwart voor' schuift de kleine wijzer al richting het volgende uur, maar het is nog 10 uur.",
          "3": "Veelgemaakte fout: de kleine wijzer verkeerd aflezen. De kleine wijzer staat tussen de 10 en de 11, niet tussen de 9 en de 10. Het uur is 10, niet 9."
        }
      }
    },
    {
      "id": "TGL-TIJD-ANALOOG-004",
      "familyId": "TGL-TIJD-ANALOOG",
      "module": "TijdGeld",
      "tier": 1,
      "levelCode": "B6",
      "group": 6,
      "skill": "klokkijken",
      "subSkill": "klok_analoog",
      "questionType": "clock",
      "question": "Hoe laat is het?",
      "options": ["02:20", "04:20", "02:40", "04:10"],
      "correctAnswer": 0,
      "data": {
        "mode": "read_analog_fill",
        "target": {"hours": 2, "minutes": 20, "format": "24h"},
        "minuteStep": 5,
        "showNumbers": true,
        "showMinuteTicks": true
      },
      "conceptId": "clock_reading_analog_minutes",
      "variantIndex": 4,
      "stimulusAids": [
        {
          "type": "clock",
          "data": {"hours": 2, "minutes": 20}
        }
      ],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Minuten tellen",
            "content": "De kleine wijzer staat tussen de 2 en de 3, dus het uur is 2. De grote wijzer wijst naar de 4. Tel de minuten: elke streep is 5 minuten. 4 × 5 = 20 minuten. Het antwoord is 02:20."
          }
        }
      ],
      "feedback": {
        "explanationText": "Strategie: lees eerst de kleine wijzer (uur), dan de grote wijzer (minuten). Stap 1: de kleine wijzer staat tussen de 2 en de 3, dus het uur is 2. Stap 2: de grote wijzer wijst naar de 4 — tel: 4 × 5 = 20 minuten. Stap 3: het is 02:20.",
        "distractorExplanations": {
          "0": "Correct! De kleine wijzer staat bij de 2 en de grote wijzer bij de 4 (20 minuten). Dat is 02:20.",
          "1": "Veelgemaakte fout: de kleine en grote wijzer verwarren. De kleine wijzer (kort) staat bij de 2 (= uur), de grote wijzer (lang) bij de 4 (= minuten). Het uur is 2, niet 4.",
          "2": "Veelgemaakte fout: de grote wijzer spiegelen. De grote wijzer staat op de 4 (20 minuten), niet op de 8 (40 minuten). Tel vanaf de 12 met de klok mee: 4 × 5 = 20.",
          "3": "Veelgemaakte fout: beide wijzers omdraaien. De kleine wijzer staat bij de 2 (niet 4) en de grote wijzer bij de 4 (niet 2). Onthoud: kort = uur, lang = minuten."
        }
      }
    },
    {
      "id": "TGL-TIJD-ANALOOG-005",
      "familyId": "TGL-TIJD-ANALOOG",
      "module": "TijdGeld",
      "tier": 1,
      "levelCode": "B6",
      "group": 6,
      "skill": "klokkijken",
      "subSkill": "klok_analoog",
      "questionType": "clock",
      "question": "Hoe laat is het op deze klok?",
      "options": ["12:00", "06:00", "12:30", "00:00"],
      "correctAnswer": 0,
      "data": {
        "mode": "read_analog_fill",
        "target": {"hours": 12, "minutes": 0, "format": "24h"},
        "minuteStep": 5,
        "showNumbers": true,
        "showMinuteTicks": true
      },
      "conceptId": "clock_reading_analog_twelve",
      "variantIndex": 5,
      "stimulusAids": [
        {
          "type": "clock",
          "data": {"hours": 12, "minutes": 0}
        }
      ],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Twaalf uur aflezen",
            "content": "Beide wijzers staan op de 12. De kleine wijzer wijst naar 12 uur en de grote wijzer naar 0 minuten. Het antwoord is 12:00 (twaalf uur precies)."
          }
        }
      ],
      "feedback": {
        "explanationText": "Strategie: kijk waar beide wijzers staan. Stap 1: beide wijzers staan op de 12. Stap 2: de kleine wijzer op 12 = 12 uur. De grote wijzer op 12 = 0 minuten. Stap 3: het is 12:00 (twaalf uur precies, oftewel 's middags).",
        "distractorExplanations": {
          "0": "Correct! Beide wijzers staan op de 12, dat is 12:00 (twaalf uur precies).",
          "1": "Veelgemaakte fout: de 12 en de 6 verwarren. De kleine wijzer staat op de 12 (bovenaan), niet op de 6 (onderaan). 12 uur en 6 uur liggen precies tegenover elkaar op de klok.",
          "2": "Veelgemaakte fout: de grote wijzer verkeerd aflezen. De grote wijzer staat op de 12 (0 minuten), niet op de 6 (30 minuten). Als beide wijzers op de 12 staan, is het precies een heel uur.",
          "3": "Veelgemaakte fout: 12:00 en 00:00 verwarren. 12:00 is twaalf uur 's middags. 00:00 is middernacht (begin van een nieuwe dag). Op een analoge klok zien beide er hetzelfde uit, maar de context bepaalt welke het is."
        }
      }
    },
    {
      "id": "TGL-TIJD-ANALOOG-006",
      "familyId": "TGL-TIJD-ANALOOG",
      "module": "TijdGeld",
      "tier": 1,
      "levelCode": "B6",
      "group": 6,
      "skill": "klokkijken",
      "subSkill": "klok_analoog",
      "questionType": "clock",
      "question": "Hoe laat is het?",
      "options": ["05:55", "06:55", "05:50", "06:00"],
      "correctAnswer": 0,
      "data": {
        "mode": "read_analog_fill",
        "target": {"hours": 5, "minutes": 55, "format": "24h"},
        "minuteStep": 5,
        "showNumbers": true,
        "showMinuteTicks": true
      },
      "conceptId": "clock_reading_analog_five_to",
      "variantIndex": 6,
      "stimulusAids": [
        {
          "type": "clock",
          "data": {"hours": 5, "minutes": 55}
        }
      ],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Vijf voor aflezen",
            "content": "De kleine wijzer staat bijna bij de 6, maar nog niet helemaal. Het uur is dus 5. De grote wijzer wijst naar de 11, dat is 55 minuten (5 voor 6). Het antwoord is 05:55."
          }
        }
      ],
      "feedback": {
        "explanationText": "Strategie: lees eerst de kleine wijzer (uur), dan de grote wijzer (minuten). Stap 1: de kleine wijzer staat bijna bij de 6, maar nog niet helemaal — het uur is dus 5. Stap 2: de grote wijzer wijst naar de 11 — tel: 11 × 5 = 55 minuten. Stap 3: het is 05:55 (vijf voor zes).",
        "distractorExplanations": {
          "0": "Correct! De kleine wijzer staat nog bij de 5 en de grote wijzer bij de 11 (55 minuten). Dat is 05:55.",
          "1": "Veelgemaakte fout: het volgende uur aflezen. De kleine wijzer staat bijna bij de 6, maar nog niet helemaal. Zolang de kleine wijzer de 6 niet bereikt heeft, is het uur nog 5.",
          "2": "Veelgemaakte fout: de grote wijzer verkeerd tellen. De grote wijzer staat op de 11, niet op de 10. Tel: 11 × 5 = 55 minuten, niet 10 × 5 = 50 minuten.",
          "3": "Veelgemaakte fout: de grote wijzer negeren. De grote wijzer staat op de 11 (55 minuten), niet op de 12 (0 minuten). Het is bijna 6 uur, maar nog niet helemaal — er ontbreken nog 5 minuten."
        }
      }
    }
  ]
}
